export default __webpack_public_path__ + "static/brick-texture-df2ac73376ec056f4b5bd24115e6b383.png";